export const toggleStringOnArray = (array: string[], string: string, limit = Infinity) => {
  if (!array.includes(string) && array.length < limit) {
    return [...array, string];
  }
  return array.filter((el) => el !== string);
};
